/* eslint-disable max-len */

export const port = process.env.PORT || 3000
export const host = process.env.WEBSITE_HOSTNAME || `localhost:${port}`

export const databaseUrl = process.env.DATABASE_URL || 'sqlite:database.sqlite'

export const analytics = {

  // https://analytics.google.com/
  google: {
    trackingId: process.env.GOOGLE_TRACKING_ID // UA-XXXXX-X
  }

}

export const auth = {

  jwt: { secret: process.env.JWT_SECRET || 'AG FIND AN IFA' },

  forgerock: {
    authorization_server: process.env.APP_AG_ID_SERVER_LANDING || 'https://login.secure.allangray.co.za/am',
    client_secret: process.env.APP_AG_ID_CLIENT_SECRET || '8f1e811a-ce4b-4c0d-aecf-a208812e53fd',
    client_id: process.env.APP_AG_ID_CLIENT_ID || 'find_an_ifa',
    redirect_uri: process.env.APP_AG_ID_REDIRECT_URI || 'https://www.allangray.co.za/find-an-ifa/adviser/edit',
    summary_endpoint: process.env.APP_AG_ADVISER_SUMMARY_ENDPOINT || 'https://api.allangray.co.za/find-an-adviser/adviser-summary/v1'
  },

  // https://developers.facebook.com/
  facebook: {
    id: process.env.FACEBOOK_APP_ID || '186244551745631',
    secret: process.env.FACEBOOK_APP_SECRET || 'a970ae3240ab4b9b8aae0f9f0661c6fc'
  },

  // https://cloud.google.com/console/project
  google: {
    id: process.env.GOOGLE_CLIENT_ID || '251410730550-ahcg0ou5mgfhl8hlui1urru7jn5s12km.apps.googleusercontent.com',
    secret: process.env.GOOGLE_CLIENT_SECRET || 'Y8yR9yZAhm9jQ8FKAL8QIEcd'
  },

  // https://apps.twitter.com/
  twitter: {
    key: process.env.TWITTER_CONSUMER_KEY || 'Ie20AZvLJI2lQD5Dsgxgjauns',
    secret: process.env.TWITTER_CONSUMER_SECRET || 'KTZ6cxoKnEakQCeSpZlaUCJWGAlTEBJj0y2EMkUBujA7zWSvaQ'
  },

  hereMaps: {
    apiKey: process.env.REACT_APP_HERE_MAPS_KEY || '9_g4Ap0h1dGweDwm4tToG1medG63IDtyLIJhct54YA8',
    baseUrl: 'https://autocomplete.search.hereapi.com/v1/autocomplete',
    lookupUrl: 'https://lookup.search.hereapi.com/v1/lookup'
  }

}

export const servers = {
  apiBase: typeof window !== 'undefined'
    ? (window.__API__ || 'http://localhost:8080')
    : (process.env.APP_API_URL || 'http://localhost:8080')
}